<template>
  <div class="home">
    <h4 class="sub-heading">
      Tenders
    </h4>
    <div class="row">
      <div class="form-group col-md-3 col-md-push-3">
        <label class="fs">Start Date</label>
        <date-picker
          v-model="start.date"
          format="yyyy-MM-dd"
          input-class="form-control bg-white"
        />
      </div>
      <div class="form-group col-md-3">
        <label class="fs">End Date</label>
        <date-picker
          v-model="to.date"
          format="yyyy-MM-dd"
          input-class="form-control bg-white"
        />
      </div>
    </div>
    <table
      ref="tb_tenders"
      class="table table-striped small table-responsive-sm"
    >
      <thead>
        <tr>
          <th>#</th>
          <th>Tender #</th>
          <th>Description</th>
          <th>Counterparty</th>
          <th>Type</th>
          <th>Category</th>
          <th>Closing Date</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, i) in tenders"
          :key="i"
        >
          <td>{{ i + 1 }}</td>
          <td>{{ item.tender_ref_no }}</td>
          <td>{{ item.tender_title }}</td>
          <td>{{ item.org_name }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.tender_category }}</td>
          <td>{{ item.closing_date }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import $ from 'jquery';
import DatePicker from "vuejs-datepicker";
import moment from 'moment/src/moment';

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      dt: "",
      start: {
        date: moment().toDate()
      },
      to: {
        date: moment().add('week', '1').toDate()
      }
    }
  },
  computed: {
    tenders() {
      return this.$store.getters.getTenders;
    },
    period() {
      return [this.start.date, this.to.date].join();
    }
  },
  watch: {
    period() {
      if (this.start.date && this.to.date) {
        this.fetch();
      }
    },
    tenders() {
      if (this.dt) this.dt.destroy();
      setTimeout(() => {
        this.dt = $(this.$refs.tb_tenders).DataTable({
          destroy: true,
          dom: 'Bfrtip',
          buttons: [{extend: 'csvHtml5', text: 'Excel'}]
        });
      }, 3000);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.dt = $(this.$refs.tb_tenders).DataTable({
        dom: 'Bfrtip',
        buttons: [{extend: 'csvHtml5', text: 'Excel'}]
      });
    });
    this.getTenders();
  },
  methods: {
    getTenders() {
      if (!this.tenders.length) {
        this.fetch();
      }
    },
    fetch() {
      this.$store.dispatch('fetchTenders', {start: this.start.date, end: this.to.date});
    }
  }
}
</script>
